// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"cooperate"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M1.5 10.5L12 21L19.5 13.5L15 9L12 12L9 9L12 6L9 3L1.5 10.5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15 3L12 6L9 9L12 12L15 9L19.5 13.5L22.5 10.5L15 3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 6L9 3L1.5 10.5L12 21L19.5 13.5M12 6L9 9L12 12L15 9L19.5 13.5M12 6L15 3L22.5 10.5L19.5 13.5M14.3684 18.632L12 16.2637M16.7365 16.2629L14.3682 13.8945","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CooperateIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cooperate',
    ref,
    icon: element,
  },
));

CooperateIcon.displayName = 'CooperateIcon';

export default CooperateIcon;
